import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { WHY_POINTS } from "../../lib/constants";

export const WhyUs = () => {
  return (
    <section
      id="why"
      data-testid="why-section"
      className="relative py-24 md:py-32 bg-black"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-5">
            <div className="text-[11px] tracking-[0.3em] uppercase text-[#3DC0AF] font-mono font-bold">
              / WHY THUNDERBIRD
            </div>
            <h2 className="mt-4 text-4xl sm:text-5xl lg:text-6xl font-display font-black tracking-tighter leading-[0.95]">
              Built for the projects that can't wait.
            </h2>
            <p className="mt-6 text-zinc-400 leading-relaxed max-w-md">
              We combine advanced UAV hardware with disciplined ground workflows and
              an obsession for clean deliverables. The result: data your engineers,
              planners, and decision-makers can actually trust.
            </p>

            <div className="mt-10 relative aspect-[4/5] md:aspect-square rounded-2xl overflow-hidden border border-white/10 bg-black">
              <img
                src="https://customer-assets.emergentagent.com/job_tbirdgeo-preview/artifacts/to3rxj15_ChatGPT%20Image%20May%205%2C%202026%2C%2001_13_28%20PM.png"
                alt="High-density LiDAR point cloud capture under tree canopy"
                className="absolute left-0 right-0 top-0 bottom-[5.5rem] w-full h-auto object-cover"
                style={{
                  height: "calc(100% - 5.5rem)",
                  filter: "contrast(1.35) brightness(1.05) saturate(1.45)",
                  mixBlendMode: "lighten",
                }}
              />
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <div className="text-[10px] tracking-[0.3em] uppercase font-mono text-[#5EE3CE]">
                  Under canopy
                </div>
                <div className="mt-1 font-display font-bold text-xl">
                  High-density LiDAR capture
                </div>
                <div className="text-sm text-zinc-400">
                  Manitoba · Aerial LiDAR
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4">
            {WHY_POINTS.map((w, i) => (
              <motion.div
                key={w.title}
                data-testid={`why-point-${i}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.55, delay: i * 0.06 }}
                className="rounded-2xl border border-white/10 bg-white/[0.02] p-6 hover:border-white/25 transition-colors"
              >
                <span className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-[#3DC0AF]/15 text-[#5EE3CE]">
                  <Check className="h-4.5 w-4.5" strokeWidth={2.5} />
                </span>
                <h3 className="mt-5 text-lg font-display font-bold">{w.title}</h3>
                <p className="mt-2 text-sm text-zinc-400 leading-relaxed">
                  {w.desc}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
